import React, {useLayoutEffect, useRef, useState} from "react";
import {useStore} from "react-redux";
import _ from "lodash";

// import '@ant-design/compatible/assets/index.css';


import {Form, Input, Select, Checkbox, InputNumber, Radio, DatePicker, Upload} from "antd";

// import 'antd/lib/input/style/css';


// import 'antd/lib/input-number/style/css';


// import 'antd/lib/checkbox/style/css';


// import 'antd/lib/select/style/css';


// import 'antd/lib/radio/style/css';


// import 'antd/lib/form/style/css';


// import 'antd/lib/date-picker/style/css';


import moment from 'moment';
import DropZoneField from "../DropzoneField";

// antd 5 text inputs keep an internal copy of their value and re-render themselves on every keystroke before
// redux-form has propagated the change to the Field (redux-form skips re-rendering the form when only `values`
// changed, so the Field is refreshed in a second, later render). That intermediate render writes the previous
// value back into the DOM and the browser moves the caret to the end. Keeping the typed text in local state makes
// the intermediate render harmless; the store is checked after each commit so `normalize` keeps the final say,
// and when it rewrites the text the caret is put back where the user was typing.
const TypedTextInput = ({component: Component, form, input, ...rest}) => {
  const store = useStore();
  const ref = useRef(null);
  // antd wraps the native node: Input/Input.Password expose `input`, Input.TextArea exposes `resizableTextArea.textArea`.
  const nativeNode = () => ref.current && (ref.current.input || (ref.current.resizableTextArea && ref.current.resizableTextArea.textArea)) || null;
  const pendingCaret = useRef(null);
  const [draft, setDraft] = useState({prop: input.value, value: input.value});
  if (draft.prop !== input.value)
    setDraft({prop: input.value, value: input.value});
  const value = draft.prop === input.value ? draft.value : input.value;
  useLayoutEffect(() => {
    const node = nativeNode();
    if (pendingCaret.current !== null) {
      if (node && document.activeElement === node) {
        try { node.setSelectionRange(pendingCaret.current, pendingCaret.current); } catch (e) { /* input type without selection support */ }
      }
      pendingCaret.current = null;
    }
    if (draft.prop !== input.value) return;
    const formState = (store.getState().form || {})[form];
    const stored = _.get(formState && formState.values, input.name);
    const storedValue = stored === undefined || stored === null ? '' : stored;
    if (storedValue !== draft.value) {
      if (node && typeof node.selectionStart === 'number')
        pendingCaret.current = Math.max(0, node.selectionStart + String(storedValue).length - String(draft.value).length);
      setDraft({prop: input.value, value: storedValue});
    }
  });
  const onChange = (event) => {
    setDraft({prop: input.value, value: event.target.value});
    input.onChange(event);
  };
  return <Component {...input} {...rest} ref={ref} value={value} onChange={onChange}/>;
};

const isTextInput = (Component) => Component === Input || Component === Input.TextArea || Component === Input.Password;

const createField = (Component, checkbox = false, datePicker = false, icon=true, select=false,field2=false) => ({input, meta, children, hasFeedback, label, language, ...rest}) => {
  if(datePicker) {
    input.value = input.value === '' ? null : moment(input.value);
    rest['format'] = 'YYYY-MM-DD';
  }
  if(checkbox)
    input.checked = input.value === '' || input.value === 'false' || input.value === 'Off' ? false : input.value === 'true' ? true : input.value;
  if(select) {
    //input.value = input.value === '' ? undefined : input.value;
    input.onBlur=null;
  }
  if(field2)
    delete input.value;
  if(Component === Radio.Group) {
    rest.onBlur = () => {};
  }
  const hasError = meta.touched && meta.invalid;
  return (
    <Form.Item
      label={label}
      className={icon ? '' : 'no-icon'}
      validateStatus={hasError ? "error" : "success"}
      hasFeedback={hasFeedback && hasError && !checkbox}
      help={hasError && meta.error}
    >
      {isTextInput(Component)
        ? <TypedTextInput component={Component} form={meta.form} input={input} language={language} autoComplete='chrome-off' label={label} {...rest} children={children}/>
        : <Component language={language} autoComplete='chrome-off' label={label} {...input} {...rest} children={children}/>}
    </Form.Item>
  );
};

export const CreateTextField = createField(Input);
export const CreateRadioGroup = createField(Radio.Group, false, false, false);
export const CreateNumberField = createField(InputNumber);
export const CreateTextArea = createField(Input.TextArea);
export const CreatePasswordField = createField(Input.Password);
export const CreateSelectField = createField(Select, false, false, false, true);
export const CreateDatePicker = createField(DatePicker, false, true);
export const CreateCheckbox = createField(Checkbox, true);
export const CreateFileField = createField(DropZoneField);
export const CreateFileField2 = createField(Upload,false,false,false,false,true);
